var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullwidth"},[_c('signup-form'),_c('main-modal',{attrs:{"className":"office-modal","show":!_vm.hasOffice},on:{"close":_vm.closeModal}},[_c('office-modal',{on:{"done":_vm.officeFilled}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }